export const useCashierOptions = () => {
  const { data, isError, isFetching } = useCashiers()
  const options = computed(
    () =>
      data.value?.map((cashier) => ({
        value: cashier.id,
        label: cashier.username,
      })) || []
  )
  return {
    options: options,
    isError: readonly(isError),
    isFetching: readonly(isFetching),
    getLabelForValue: (value: string) =>
      computed(
        () =>
          options.value.find(
            (option) => option.value === value
          )?.label || ""
      ),
  }
}
